/**
 * @generated SignedSource<<a6b20a446e572812c6ff913989877a3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleListItem_TeamScheduleEventOccasion$data = {
  readonly __typename: string;
  readonly routine?: {
    readonly id: string;
    readonly isArchived: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionScreenRoutineDescription_Routine">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion" | "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion" | "TeamScheduleRoutineOccasionListItem_RoutineOccasion">;
  readonly " $fragmentType": "TeamScheduleListItem_TeamScheduleEventOccasion";
};
export type TeamScheduleListItem_TeamScheduleEventOccasion$key = {
  readonly " $data"?: TeamScheduleListItem_TeamScheduleEventOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleListItem_TeamScheduleEventOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleListItem_TeamScheduleEventOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleListItemTimeOfDay_TeamScheduleEventOccasion"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamScheduleRoutineOccasionListItem_RoutineOccasion"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Routine",
          "kind": "LinkedField",
          "name": "routine",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isArchived",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoutineOccasionScreenRoutineDescription_Routine"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "RoutineOccasion",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamScheduleInlineRoutineOccasionListItem_TeamScheduleInlineRoutineOccasion"
        }
      ],
      "type": "TeamScheduleInlineRoutineOccasion",
      "abstractKey": null
    }
  ],
  "type": "TeamScheduleEventOccasion",
  "abstractKey": "__isTeamScheduleEventOccasion"
};

(node as any).hash = "2fd7a128fe058c19b8bf36fbbaae6aa4";

export default node;
